export const getFirmFromUrl = function getFirmFromUrl () {
  const s = this.getState ? this.getState() : this.state
  const root = s.root || s
  const id = new URLSearchParams(window.location.search).get('id')
  return (root.firms || []).find(x => x.id === id)
}
